import { datadogRum } from "@datadog/browser-rum";
import { getIsProduction } from "library/browser";
import pkg from "../../package.json";

const clientToken = process.env.REACT_APP_DATADOG_CLIENT_TOKEN;
const applicationId = process.env.REACT_APP_DATADOG_APPLICATION_ID;
const service = process.env.REACT_APP_DATADOG_SERVICE;
const { init, ...restMethods } = datadogRum;

export function initDataDog(): void {
  // Only initialize in non-production and production env with a valid client token
  if (applicationId && clientToken) {
    const ddConfig = {
      applicationId,
      clientToken,
      service,
      site: "datadoghq.com",
      env: getIsProduction() ? "prod" : "nonprod",
      version: pkg.version,
      trackInteractions: true,
      trackSessionAcrossSubdomains: !getIsProduction(),
    };
    init(ddConfig);
  }
}

// Export datadog RUM sdk methods for manual usage.
// Ref: https://docs.datadoghq.com/real_user_monitoring/browser/data_collected/
export const {
  addRumGlobalContext,
  removeRumGlobalContext,
  getRumGlobalContext,
  setRumGlobalContext,
  getInternalContext,
  getInitConfiguration,
  addAction,
  addError,
  addTiming,
  setUser,
  removeUser,
  startView,
  startSessionReplayRecording,
  stopSessionReplayRecording,
} = restMethods;
